import { onAuthStateChanged, signInWithPopup, signOut, GoogleAuthProvider } from 'firebase/auth';
import { auth } from './firebase.service';

export const signInUser = () => signInWithPopup(auth, new GoogleAuthProvider());

export const userStateListener = (callback) => onAuthStateChanged(auth, callback);

export const signOutUser = async () => signOut(auth);
